import React from "react";

const CounterDescription = ({ boxType }) => {
  return (
    <div
      className="divColumn"
      style={{
        backgroundColor: "#2f2f2f",
        padding: "5px",
        borderRadius: ".5rem/.5rem",
        border: "3px solid grey",
      }}
    >
      <div className="textBoldWhite">{`Open ${boxType}`}</div>
    </div>
  );
};

export default CounterDescription;
